export default "__VITE_ASSET__D85K1Y3j__"